// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Schedule-Header-__week__wrapper--Xwba6","datePicker":"src-components-Schedule-Header-__week__datePicker--1yOuK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Schedule/Header/week.css
// module id = 1991
// module chunks = 0